export default "__VITE_ASSET__B$kXe7Xa__"